import {
  Card,
  CardHeader,
  Divider
} from '@mui/material';

const SettingsNotifications = (props) => (
  <form {...props}>
    <Card>
      <CardHeader
        subheader="Manage app settings"
        title="Settings"
      />
      <Divider />
    </Card>
  </form>
);

export default SettingsNotifications;
